import { IClosestChartLine } from "components/GQChart/chartInterfaces";
import { makeAutoObservable } from 'mobx';
class AnnotationStore {
    public yScales: {
        [identifier: string]: d3.ScaleLinear<number, number>;
    } = {};
    public xScale: d3.ScaleTime<number, number> = null;
    public closestLine: IClosestChartLine = null;
    public selectedMapCountry: number = null;
    constructor() {
         makeAutoObservable(this);
    }
}

const store = new AnnotationStore();

export interface IAnnoStore {
    annoStore: typeof store;
}
export default store;
